import { appState } from "../redux/redux-config";
import { apiRequestWithChecks } from "./api";

export const messages = {
  list: function (payload) {
    let token = appState().user.token;
    return apiRequestWithChecks(
      "POST",
      "/api/message/MessageList",
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  messageListForSpecificUser: function (payload, userId) {
    let token = appState().user.token;
    return apiRequestWithChecks(
      "POST",
      `/api/message/MessageListForSpecificUser?userId=${userId}`,
      {
        Authorization: "Bearer " + token,
      },
      payload
    );
  },
  bulkDelete: function (payload) {
    let token = appState().user.token;
    return apiRequestWithChecks(
      "DELETE",
      "/api/message/bulk-delete",
      {
        Authorization: "Bearer " + token,
      },
      payload,
      false
    );
  },
  emailAndSenderNames: function () {
    let token = appState().user.token;
    return apiRequestWithChecks(
      "POST",
      "/api/message/EmailAndSenderNames",
      {
        Authorization: "Bearer " + token,
      },
      null
    );
  },
};
export default messages;
